import { StylesConfig } from 'react-select';
import CreatableSelect from 'react-select/creatable';

const InsumosFiltroPeriodo = ({ handleChangeCompetencia, competencias }: iProps) => {
    const generateMonths = () => {
        let months = [];
        const now = new Date();

        // Mês atual +1
        const end = new Date(now.getFullYear(), now.getMonth() + 1);

        const current = new Date(now.getFullYear(), now.getMonth() - 3);

        while (current <= end) {
            const year = current.getFullYear();
            const month = String(current.getMonth() + 1).padStart(2, "0");
            const valueCurrent = `${year}-${month}` // YYYY-MM
            const labelCurrent = `${month}/${year}` // MM/YYYY
            months.push({
                value: valueCurrent,
                label: labelCurrent,
            });
            current.setMonth(current.getMonth() + 1);
        }
        months.push({
            value: "",
            label: "Todos"
        });
        let monthsAux = []
        for (let i = months.length - 1; i >= 0; i--) {
            monthsAux.push(months[i])
        }
        return monthsAux;
    };

    const months: any = generateMonths();

    return (
        <div style={{width: "16%", }}>
        <CreatableSelect id="competencia" name="competencia" placeholder="Competência" options={months} onChange={(choice) => { handleChangeCompetencia(choice) }} value={competencias} maxMenuHeight={41} styles={styleSelectLocais} />
        </div>
    );
};
interface iProps {
    handleChangeCompetencia: any
    competencias: any[]
}

export default InsumosFiltroPeriodo;

const styleSelectLocais: StylesConfig = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided: any, state: any) => ({
        ...provided,
        minHeight: '120px',
        maxHeight: '200px',
    }),
    menuList: (provided: any, state: any) => ({
        ...provided,
        minHeight: '120px',
        maxHeight: '200px',
    }),
}
